import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const trailingWhiteSpace = (control: FormControl) => {
    if (control?.value?.endsWith(" ")) {
        return { trailingWhiteSpace: messages.validation.trailingWhiteSpace };
    }
};
